module.exports = __webpack_public_path__ + "static/img/7.7c76114e.png";